export default __webpack_public_path__ + "static/media/github.aca2dd91.svg";